import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const post849ReviewScorecardConfigSchema = z.object({
  windowDays: z
    .number()
    .int()
    .min(1)
    .max(90)
    .default(7)
    .describe(
      "Days the scorecard covers, ending at the scheduled time; compared with the same number of days before",
    ),
  slackChannel: z
    .string()
    .trim()
    .optional()
    .describe("Slack channel to post the scorecard to, e.g. #ship-and-debit"),
  emailTo: z
    .array(z.string().trim().email())
    .default([])
    .describe("Addresses to email the scorecard to"),
});

export type Post849ReviewScorecardConfig = z.infer<
  typeof post849ReviewScorecardConfigSchema
>;

export const post849ReviewScorecardStep = defineStepConfig({
  type: "post_849_review_scorecard",
  name: "Post 849 Review Scorecard",
  description:
    "Measures the 849 email review per supplier (read-only) — classifier verdicts against the team's labels, the claim link, rows placed, responses opened and money pending — against the window before, and posts it to Slack and/or email.",
  category: "Integration",
  libraryModule: "ShipAndDebit",
  inputSchema: z.object({
    scheduledTime: z
      .string()
      .optional()
      .describe("Scheduled fire time from the schedule trigger"),
  }),

  outputSchema: z.object({
    from: z.string().describe("Window start (ISO)"),
    to: z.string().describe("Window end (ISO)"),
    suppliers: z.number().describe("Suppliers on the scorecard"),
    suppliersMoved: z
      .number()
      .describe("Suppliers with at least one number that moved"),
    slackPosted: z.boolean().describe("Whether the Slack post was queued"),
    emailedTo: z.array(z.string()).describe("Addresses the scorecard went to"),
  }),

  configSchema: post849ReviewScorecardConfigSchema,

  emits: [] as const,

  execution: {
    startToCloseTimeout: "10 minutes",
    retry: {
      maximumAttempts: 2,
      backoffCoefficient: 2,
      initialInterval: "30 seconds",
    },
  },
});
